export default __webpack_public_path__ + "static/media/Responsive Web Design - Diseño Web Responsivo - Freecodecamp.c7dd0c87.png";